export default __webpack_public_path__ + "static/media/full-screen.3e6a25a6.svg";